<div class="dialog-outer">
    <div class="">
        <div class="header" mat-dialog-title>
            {{'businessTexts.details' | translate}}
            <button mat-dialog-close class="close-btn" (click)="closeDialog()"
                matTooltip="{{'businessTexts.close' | translate}}">
                <cqes-icon icon="close" class="close-icon"></cqes-icon>
            </button>
        </div>
        <mat-dialog-content class="mat-typography con">
            <div class="details-wrapper">
                <div class="spinner-container" *ngIf="wait">
                    <div class="spinner">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div *ngIf="!wait" class="max-width">

                    <div class="row">
                        <div class="word-break"><span
                                class="label">{{'businessTexts.webIdentificationHistoryDialog.name' |
                                translate}}:</span>
                            {{getName(rowData.name)}}</div>
                        <div class="word-break"><span
                                class="label">{{'businessTexts.webIdentificationHistoryDialog.email' |
                                translate}}:</span>
                            {{rowData.email}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="spinner-container" *ngIf="wait">
                <mat-spinner class="content-box"></mat-spinner>
            </div>
            <div class="exapnd-wrapper" [ngClass]="noResponse == true ? 'show' : 'hide'">
                <mat-expansion-panel>
                    <mat-expansion-panel-header class="header-panel">
                        <mat-panel-title>
                            <div class="container-header">
                                {{'businessTexts.webIdentificationHistoryDialog.infoSinedDoc' |
                                translate}}
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container>
                        <mat-table [dataSource]="tableDocumentList">
                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> {{'historyTexts.documentStatus' |
                                    translate}}</mat-header-cell>
                                <mat-cell *matCellDef="let doc">
                                    <div class="cell" [ngSwitch]="doc.documentStatus">
                                        <div matTooltip="{{'businessTexts.identificationTable.successfully' | translate}}"
                                            *ngSwitchCase="'SUCCESSFULLY SIGNED'">
                                            <cqes-icon icon="done"></cqes-icon>
                                        </div>

                                        <span *ngSwitchDefault>
                                            <cqes-icon icon="hourglass_empty"
                                                class="text-warning row-status-identification"></cqes-icon>
                                            {{ doc.documentStatus }}
                                        </span>
                                    </div>
                                </mat-cell>

                            </ng-container>

                            <ng-container matColumnDef="filename">
                                <mat-header-cell *matHeaderCellDef
                                    class="custom-cell-info-file">{{'historyTexts.docName' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let doc" class="custom-cell-info-file"
                                    matTooltip="{{  doc.fileDesc }}">
                                    <div class="cell-info-file">
                                        <span> {{ doc.fileName }}</span>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="sentTimestamp">
                                <mat-header-cell *matHeaderCellDef>{{ 'businessTexts.sentDate' | translate
                                    }}</mat-header-cell>
                                <mat-cell *matCellDef="let doc">
                                    <div class="created-at-cell">
                                        <div>{{ doc.createdAt | date: 'dd.MM.yy г.' }}</div>
                                        <div>{{ doc.createdAt | date: 'HH:mm ч.' }}</div>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="deadlineTimestamp">
                                <mat-header-cell *matHeaderCellDef> {{'businessTexts.signDeadline'
                                    | translate}} </mat-header-cell>
                                <mat-cell *matCellDef="let doc">
                                    <div class="created-at-cell">
                                        <div>{{ doc.validUntil | date: 'dd.MM.yy г.' }}</div>
                                        <div>{{ doc.validUntil | date: 'HH:mm ч.' }}</div>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="signedTimestamp">
                                <mat-header-cell *matHeaderCellDef>{{ 'businessTexts.signedDate' | translate
                                    }}</mat-header-cell>
                                <mat-cell *matCellDef="let doc">
                                    <div class="created-at-cell">
                                        <div>{{ doc.signedAt | date: 'dd.MM.yy г.' }}</div>
                                        <div>{{ doc.signedAt | date: 'HH:mm ч.' }}</div>
                                    </div>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef>{{ 'businessTexts.actions' | translate
                                    }}</mat-header-cell>
                                <mat-cell *matCellDef="let doc">
                                    <button mat-icon-button
                                        matTooltip="{{ 'businessTexts.downloadDocument' | translate }}"
                                        (click)=" $event.stopPropagation(); onDownloadDocument(doc);">
                                        <mat-icon>
                                            {{ isDownloadingEIDDoc() ? 'hourglass_empty' : 'file_download' }}
                                        </mat-icon>
                                    </button>
                                    <button mat-icon-button [ngClass]="doc.asJson ? 'show' : 'hide'"
                                        matTooltip="{{ 'businessTexts.downloadDocumentJson' | translate }}"
                                        (click)=" $event.stopPropagation(); downloadIdentificationFile(doc);">
                                        <mat-icon>
                                            {{ isDownloadingEIDDoc() ? 'hourglass_empty' : 'file_download' }}
                                        </mat-icon>
                                    </button>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumnsDocumentList"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumnsDocumentList;"></mat-row>
                        </mat-table>
                    </ng-container>
                </mat-expansion-panel>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <div class="btn-wrapper">
                <button class="mat-mdc-raised-button action-button" mat-dialog-close
                    (click)="closeDialog()">{{'close'|translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>